import styled from '@emotion/styled';
import { PANEL_PADDING } from '../../../../../utils/dimensions';

export const PanelBodyWrapper = styled.div`
  padding: ${PANEL_PADDING}px ${PANEL_PADDING}px 0 ${PANEL_PADDING}px;
  overflow: hidden;
  height: calc(100vh - 104px);
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
`;
